import React from "react";
import styled, {createGlobalStyle, css} from "styled-components";
import DatePicker from "react-datepicker";

export const mainColor = css`${props => props.theme.color.mainColor}`;
export const topicColor = css`${props => props.theme.color.topicColor}`;
export const bgColor = css`${props => props.theme.color.bgColor}`
export const subColor = css`${props => props.theme.color.subColor}`;
export const textColor = css`${props => props.theme.color.textColor}`;
export const reverseTextColor = css`${props => props.theme.color.reverseTextColor}`;
export const borderColor = css`${props => props.theme.color.borderColor}`;
export const lightGray = css`${props => props.theme.color.lightGray}`;
export const whiteColor = css`${props => props.theme.color.whiteColor}`;

export const GlobalStyles = createGlobalStyle`
  :root {
    --theme-main: ${({theme}) => theme.color.mainColor};
    --theme-primary: ${({theme}) => theme.color.primary};
    --theme-primary-strong: ${({theme}) => theme.color.primaryStrong};
    --theme-primary-hover: ${({theme}) => theme.color.primaryHover};
    --theme-primary-light: ${({theme}) => theme.color.primaryLight};
    --theme-primary-soft: ${({theme}) => theme.color.primarySoft};
    --theme-primary-soft-hover: ${({theme}) => theme.color.primarySoftHover};
    --theme-primary-softest: ${({theme}) => theme.color.primarySoftest};
    --theme-primary-border: ${({theme}) => theme.color.primaryBorder};
    --theme-primary-border-strong: ${({theme}) => theme.color.primaryBorderStrong};
    --theme-primary-opacity-05: ${({theme}) => theme.color.primaryOpacity05};
    --theme-primary-opacity-08: ${({theme}) => theme.color.primaryOpacity08};
    --theme-primary-focus-ring: ${({theme}) => theme.color.primaryFocusRing};
    --theme-primary-opacity-12: ${({theme}) => theme.color.primaryOpacity12};
    --theme-primary-opacity-16: ${({theme}) => theme.color.primaryOpacity16};
    --theme-primary-shadow: ${({theme}) => theme.color.primaryShadow};
    --theme-primary-opacity-20: ${({theme}) => theme.color.primaryOpacity20};
    --theme-primary-opacity-45: ${({theme}) => theme.color.primaryOpacity45};
    --theme-primary-transparent: ${({theme}) => theme.color.primaryTransparent};
    --theme-primary-strong-opacity-06: ${({theme}) => theme.color.primaryStrongOpacity06};
    --theme-primary-strong-opacity-08: ${({theme}) => theme.color.primaryStrongOpacity08};
    --theme-primary-strong-shadow: ${({theme}) => theme.color.primaryStrongShadow};
    --theme-primary-strong-opacity-12: ${({theme}) => theme.color.primaryStrongOpacity12};
    --theme-primary-strong-opacity-14: ${({theme}) => theme.color.primaryStrongOpacity14};
    --theme-primary-strong-opacity-20: ${({theme}) => theme.color.primaryStrongOpacity20};
    --accent-red: ${({theme}) => theme.color.accentRed};
    --accent-red-soft: ${({theme}) => theme.color.accentRedSoft};
    --accent-red-border: ${({theme}) => theme.color.accentRedBorder};
    --accent-orange: ${({theme}) => theme.color.accentOrange};
    --accent-orange-soft: ${({theme}) => theme.color.accentOrangeSoft};
    --accent-orange-border: ${({theme}) => theme.color.accentOrangeBorder};
    --accent-yellow: ${({theme}) => theme.color.accentYellow};
    --accent-yellow-soft: ${({theme}) => theme.color.accentYellowSoft};
    --accent-yellow-border: ${({theme}) => theme.color.accentYellowBorder};
    --accent-green: ${({theme}) => theme.color.accentGreen};
    --accent-green-soft: ${({theme}) => theme.color.accentGreenSoft};
    --accent-green-border: ${({theme}) => theme.color.accentGreenBorder};
    --accent-purple: ${({theme}) => theme.color.accentPurple};
    --accent-purple-soft: ${({theme}) => theme.color.accentPurpleSoft};
    --accent-purple-border: ${({theme}) => theme.color.accentPurpleBorder};
  }

  html {
    font-size: 14px;
    word-break: break-all;
  }
  body {
    margin: 0;
    font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }
  html, body, button, input, textarea, pre {
    font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    color: ${textColor};
  }
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background-color: #f5f5f5;
    &-track {
      box-shadow: inset 0 0 6px rgba(95, 78, 78, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      background-color: #f5f5f5;
    }
  }
  
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(85, 85, 85, 0.15);
  }
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  }
  a {
    text-decoration: none;
    color: #777
  }
  ul,li,dd,dl,dt {
    text-decoration: none;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  table {
    border-spacing: 0;
  }
  article {
    margin: 0 auto;
  }

  article h1 {
    font-size: 2em;
  }

  article h2 {
    font-size: 1.7em;
  }

  article h3 {
    font-size: 1.5em;
  }

  article h4 {
    font-size: 1.2em;
  }

  article h5 {
    font-size: 1em;
  }

  article h6 {
    font-size: .07em;
  }
  

  #container {
    display: flex;
  }
  
  aside {
    position: -webkit-sticky; /* 사파리 브라우저 지원 */
    position: sticky;
    top: 0;
    align-self: flex-start;
  }
  button {
    border: 0;
    border-radius: 5px;
    cursor: pointer;
  }
  input, textarea {
    outline: none;
  }
  textarea:hover {
    border: 1px solid #b3b3b3;
  }
  input::placeholder{
    color: #a2aab2;
  }
  input[type='text']:read-only {
    background-color: #f9fafb;
    cursor: not-allowed;
    &:hover {
      border-color: #e5e5e5;
    }
  }
  input[type='text']:hover {
    border: 1px solid #b3b3b3;
  }
  input[type="radio"] {
    vertical-align: middle;
    appearance: none;
    width: 20px;
    height: 20px;
    background-image: url('/assets/images/common/selectcircle_off.png');
    background-image: -webkit-image-set(url('/assets/images/common/selectcircle_off.png') 1x,url('/assets/images/common/selectcircle_off@2x.png') 2x, url('/assets/images/common/selectcircle_off@3x.png') 3x)
  }
  input[type="radio"]:checked {
    background-image: url('/assets/images/common/selectcircle_on.png');
    background-image: -webkit-image-set(url('/assets/images/common/selectcircle_on.png') 1x,url('/assets/images/common/selectcircle_on@2x.png') 2x, url('/assets/images/common/selectcircle_on@3x.png') 3x)
  }
  label {
    display: flex;
    margin-right: 10px;
  }

  .react-datepicker__input-container input[type='text']{
    border: 0;
    //height: calc(35px - 2px);
  }
  .checkbox-type-a {
    display: none;
  }
  .checkbox-type-a + label {
    vertical-align: top;
  }
  .checkbox-type-a + i{
    display: inline-block;
    margin: 0 8px;
    width: 14px;
    height: 20px;
    background-image: url('/assets/images/common/checkbox.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox.png') 1x,url('/assets/images/common/checkbox@2x.png') 2x, url('/assets/images/common/checkbox@3x.png') 3x);
    background-repeat: no-repeat;
    background-position: center;
    vertical-align: top;
  }

  .checkbox-type-a:checked + i{
    background-image: url('/assets/images/common/checkbox_on.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_on.png') 1x,url('/assets/images/common/checkbox_on@2x.png') 2x, url('/assets/images/common/checkbox_on@3x.png') 3x);
  }

  .checkbox-type-b {
    display: none;
  }
  .checkbox-type-b + label {
    vertical-align: top;
  }
  .checkbox-type-b + i{
    display: inline-block;
    margin: 0 8px;
    width: 30px;
    height: 30px;
    background-image: url('/assets/images/common/checkbox_off_B.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_off_B.png') 1x,url('/assets/images/common/checkbox_off_B@2x.png') 2x, url('/assets/images/common/checkbox_off_B@3x.png') 3x);
    background-repeat: no-repeat;
    background-position: center;
    vertical-align: top;
  }

  .checkbox-type-b:checked + i{
    background-image: url('/assets/images/common/checkbox_on_B.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_on_B.png') 1x,url('/assets/images/common/checkbox_on_B@2x.png') 2x, url('/assets/images/common/checkbox_on_B@3x.png') 3x);
  }

  .checkbox-type-c {
    display: none;
  }

  .checkbox-type-c + label {
    vertical-align: top;
  }
  .checkbox-type-c + i{
    display: inline-block;
    margin: 0 10px 0 6px;
    width: 35px;
    height: 35px;
    background-image: url('/assets/images/common/checkbox_off_C.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_off_C.png') 1x,url('/assets/images/common/checkbox_off_C@2x.png') 2x, url('/assets/images/common/checkbox_off_C@3x.png') 3x);
    background-repeat: no-repeat;
    background-position: center;
    vertical-align: top;
  }

  .checkbox-type-c:checked + i{
    background-image: url('/assets/images/common/checkbox_on_C.png');
    background-image: -webkit-image-set(url('/assets/images/common/checkbox_on_C.png') 1x,url('/assets/images/common/checkbox_on_C@2x.png') 2x, url('/assets/images/common/checkbox_on_C@3x.png') 3x);
  }
  
  .border-r {
    border-right: 1px solid ${lightGray}
  }
  .border-t {
    border-top: 1px solid ${lightGray}
  }

  .fadeOut {
    animation: 0.5s fadeOutAnimation;
    animation-fill-mode: forwards;
  }

  .fadeIn {
    animation: 0.5s fadeInAnimation;
    animation-fill-mode: forwards;
  }

  .icon-mode {
    padding-left: 18px !important;
    width: 60px !important;
    height: 60px !important;
    overflow: hidden;
    border-radius: 15px;
  }
  .list-mode {
    overflow: hidden;
  }
  .icon-mode > div{
    transition-duration: 0.5s;
  }
  .icon-mode + div {
    transition-duration: 0.5s;
    height: 0 !important;
  }
  .list-mode > div {
    transition-duration: 0.5s;
    margin-left: 0px;
  }

  .active > a {
    background-color: transparent;
  }

  .active span {
    color: ${subColor}
  }

  .slide-down-1 {
    animation: 0.5s slideDownAnimation1;
    animation-fill-mode: forwards;
  }

  .slide-down-2 {
    animation: 0.5s slideDownAnimation2;
    animation-fill-mode: forwards;
  }
  .slide-down-3 {
    animation: 0.5s slideDownAnimation3;
    animation-fill-mode: forwards;
  }

  .slide-down-4 {
    animation: 0.5s slideDownAnimation4;
    animation-fill-mode: forwards;
  }

  .slide-down-5 {
    animation: 0.5s slideDownAnimation5;
    animation-fill-mode: forwards;
  }
  

  .slide-up {
    animation: 0.5s slideUpAnimation;
    animation-fill-mode: forwards;
    overflow: hidden;
  }

  .react-switch-checkbox {
    height: 0;
    width: 0;
    visibility: hidden;
    display: none;
  }

  .react-switch-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 68px;
    height: 30px;
    background: ${lightGray};
    border-radius: 68px;
    position: relative;
    transition: background-color .2s;
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  }

  .react-switch-label .react-switch-button {
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    width: 22px;
    height: 22px;
    border-radius: 22px;
    transition: 0.2s;
    background: #fff;
    box-shadow: 0 2px 3px 0 rgba(10, 10, 10, 0.4);
  }

  .react-switch-checkbox:checked + .react-switch-label .react-switch-button {
    left: calc(100% - 4px);
    transform: translateX(-100%);
  }

  .react-switch-checkbox:checked + .react-switch-label {
    background: ${mainColor};
  }

  .react-switch-label:active .react-switch-button {
    width: 22px;
  }

  .handled {
    cursor: move;
    cursor: grab;
  }
  .handled:active {
    cursor: grabbing;
  }
  
  .ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap !important;
    overflow: hidden;
  }
  
  .line-clamp_2 {
    overflow: hidden;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical
  }
  
  .won:after {
    content: '원';
    margin-left: 5px;    
  }
  
  .pct:after {
    content: '%';
    margin-left: 5px;
    color: ${textColor}
  }
  
  .count:after {
    content: '건';
    margin-left: 5px;    
  }

  @keyframes slideUpAnimation {
    0% {
      height: 97px;
    }
    100% {
      height: 0;
    }
  }

  @keyframes slideDownAnimation1 {
    0% {
      height: 0;
    }
    100% {
      height: 68px;
    }
  }

  @keyframes slideDownAnimation2 {
    0% {
      height: 0;
    }
    100% {
      height: 100px;
    }
  }

  @keyframes slideDownAnimation3 {
    0% {
      height: 0;
    }
    100% {
      height: 150px;
    }
  }

  @keyframes slideDownAnimation4 {
    0% {
      height: 0;
    }
    100% {
      height: 180px;
    }
  }
  
  @keyframes slideDownAnimation5 {
    0% {
      height: 0;
    }
    100% {
      height: 210px;
    }
  }

  @keyframes slideDownAnimation6 {
    0% {
      height: 0;
    }
    100% {
      height: 210px;
    }
  }

  @keyframes fadeOutAnimation {
    0% {
      opacity: 1;
    }
    100% {
      height: 0;
      pointer-events: none;
      opacity: 0;
    }
  }

  @keyframes fadeInAnimation {
    0% {
      opacity: 0;
    }
    100% {
      display: block;
      opacity: 1;
    }
  }
  .react-confirm-alert {
    &-body {
      font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      padding: 25px;
      font-size: 15px;
      > h1 {
        font-size: 20px;
        margin-bottom: 10px;
      }
      &-element {
        overflow: auto !important;
      }
    }
    &-overlay {
      background-color: rgba(0, 0, 0, .7)
    }
    &-button-group {
      justify-content: center;
      margin-top: 30px
    }
    
  }
`

export const inputStyle = {
  indicatorSeparator: () => null,
  container: (styles) => ({
    ...styles,
    width: '100%',
  }),
  menuPortal: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
  control: (styles,{isFocused,isDisabled}) => ({
    ...styles,
    backgroundColor: isDisabled ?'#F9FAFB' : 'white',
    border: '1px solid #e5e5e5',
    height: 35,
    minHeight: 35,
    borderRadius: 5,
    boxShadow: isFocused && `0 0 0 1px var(--theme-main)`,
    ':hover': {
      ...styles[':hover'],
      borderColor: isFocused && `var(--theme-main)`
    }
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor:
        isDisabled ? undefined :
          isSelected ? `var(--theme-main)` :
            isFocused ? 'var(--theme-primary)'
              :undefined,
      color:
        isDisabled ? '#222' :
          isSelected ? '#fff' : '#222',
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled ?
          isSelected ? `var(--theme-main)`
            : undefined
            :undefined

      }
    }
  },
  input: (styles) => ({
    ...styles,
    height: 26,
    borderRadius: 5,
  }),
  placeholder: (styles) => ({
    ...styles
  }),
  singleValue: (styles, { data }) => ({
    ...styles
  }),
};

export const TextMainColor = styled.span`
  color: ${mainColor};
  font-weight: bold;
`
export const BoardContainer = styled.div`
  padding: 30px 30px 10px 30px;
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: #f8f8f8;
  border-radius: 8px 0px 8px 8px;
`

export const TitleContainer = styled.div`
  display: flex;
  min-height: 58px;
  align-items: flex-start;
  -webkit-box-pack: justify;
  justify-content: space-between;
  gap: 18px;
  & h1 {
    font-size: 22px;
    font-weight: 750;
  }
`
export const Board = styled.div`
  margin-bottom: 10px;
  width: 100%;
  min-width: 1200px;
  background-color: #fff;
  //padding: 0 40px 40px 40px;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  border: solid 1px ${borderColor};
`

export const BoardTap = styled.div`
  margin: 0 0 34px 0;
  width: 100%;
  background-color: #fff;
  padding: 30px 40px;
  border-radius: 0 20px 20px 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
`

export const BoardTapTitle = styled.div`
  margin-top: 34px;
  padding: 12px 0;
  width: 300px;
  background-color: #fff;
  text-align: center;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  font-size: 17px;
  font-weight: bold;
`

export const BoardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 12px;
  width: 100%;
  font-weight: 700;
  font-size: 15px;
  &> div:first-child {
    font-size: 14px;
    font-weight: 600;
  }
`

export const BoardSearchDetail = styled.div`
  padding: 10px;
`

export const DashBoardCard = styled.div`
  margin-bottom: 14px;
  width: 100%;
  background-color: #fff;
  padding: 20px 22px;
  border-radius: 10px;
  border: solid 1px ${borderColor};
  box-shadow: 0 7px 22px rgba(30, 58, 138, .055);
`

export const DashBoardColSpan2 = styled.div`
  display: flex;
  width: 50%;
`

export const DashBoardHeader = styled.div`
  margin-bottom: 16px;
  width: 100%;
  color: #1e293b;
  font-size: 14px;
  font-weight: 750;
`

export const BoardTableContainer = styled.div`
  & > table {
    width: 100%;
    border-top: 1px solid ${lightGray};
    border-bottom: 1px solid ${lightGray};
    & tr {
      & th {
        padding: 14px 0;
        background-color: #fafafa;
        font-size: 15px;
        color: #b2b2b2;
        font-weight: normal;
        white-space: nowrap;
      }
      & td {
        padding: 14px 0;
        word-break: break-word;
        border-top: 1px solid ${lightGray};
        text-align: center;
        & a {
          border-bottom: 1px solid #777;
        }
      }
    }
  }
  
`
export const ChartTooltip = styled.div`
  background: #fff;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 13px;
  p:first-child {
    font-size: 12px;
    margin-bottom: 3px;
    color: #777;
  }
`

export const RowSpan = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-top: 15px;
`

export const ColSpan1 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 25%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

export const ColSpan2 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 50%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

export const ColSpan3 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 75%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

export const ColSpan4 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

export const ColFraction = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 33.333333%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
  & > Select {
    width: 10%;
  }
`
export const ColTitle = styled.div`
  padding: 0 10px;
  min-width: 70px;
  text-align: left;
  white-space: nowrap;
`

export const AgentType = styled.div`
  padding: 0 10px;
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  background-color: #f9fafb;
  height: 45px;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  & label {
    white-space: nowrap;
  }
`
export const DateContainer = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid ${lightGray};
  border-radius: 5px;
  overflow: hidden;
`

export const CalendarBox = styled.div`
  display: flex;
  width: 55px;
  border-right: 1px solid ${lightGray};
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
`

const CalendarSvg = ({className, ...props}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path d="M7 3v3M17 3v3M4.5 9h15M6.5 5h11a2 2 0 0 1 2 2v11.5a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 12.5h.01M12 12.5h.01M16 12.5h.01M8 16.5h.01M12 16.5h.01M16 16.5h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const CalendarIcon = styled(CalendarSvg)`
  width: 18px;
  height: 20px;
  color: #64748b;
`

export const CustomDatePicker = styled(DatePicker)`
  border: none !important;
  color: #a2aab2;
  font-size: 14px;
  width: 100%;
  padding: 0 20px;
`

export const RangePicker = styled.div`
  padding: 0 20px;
  display: flex;
  justify-content: space-around;
  width: 100%;
  align-items: center;
  background-color: #f9fafb;
  height: 35px;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  color: #777;
  & div {
    cursor: pointer;
    white-space: nowrap;
  }
`

export const SearchInput = styled.div`
  position: relative;
  width: 100%;
  & input[type='text'] {
    padding: 0 20px;
    width: 100%;
    height: 35px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    &:hover {
      border: 1px solid #b3b3b3;
    }
  }
`
export const ResetButton = styled.button`
  padding: 0 15px;
  height: 35px;
  border: 1px solid ${lightGray};
  background-color: ${whiteColor};
  border-radius: 5px;
`
export const SearchButton = styled.button`
  width: 140px;
  height: 35px;
  border: 1px solid ${lightGray};
  background-color: ${mainColor};
  color: ${whiteColor};
  border-radius: 5px;
`

export const BoardSearchResult = styled.div`
  margin: 20px 0;
`

export const BoardSearchResultTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0 0 20px 0;
  & span {
    color: ${mainColor};
  }
`

export const SaveExcelContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const SaveExcelButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 35px;
  border: 1px solid;
  color: ${mainColor};
  background-color:  ${whiteColor};
  border-color:  ${mainColor};
  &.listUp {
    &:after {
      background-image: url("/assets/images/common/icon_listup_off.png");
    }
    &:hover:after{
      background-image: url("/assets/images/common/icon_listup_on.png");
    }
  }
  &:after {
    margin-left: 5px;
    display: inline-block;
    content:"";
    width: 20px;
    height: 20px;
    background-image: url("/assets/images/common/icon_excel_on.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px;
  }
  &:hover {
    color: ${whiteColor};
    background-color:  ${mainColor};
    border-color:  ${whiteColor};
    &:after{
      background-image: url("/assets/images/common/icon_excel_off_white.png");
    }
  }
`
export const ChartContainer = styled.div`
  margin: 16px 0 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
`

export const Span1 = styled.span`
  display: inline-block;
  width: 60px;
`
export const Span2 = styled.span`
  display: inline-block;
  width: 100px;
`
export const Span3 = styled.span`
  display: inline-block;
  width: 100px;
`
export const Span4 = styled.span`
  display: inline-block;
  width: 120px;
`

export const SubmitContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  width: 100%;
  & button {
    margin: 8px;
    width: 200px;
    height: 60px;
    font-size: 16px;
    cursor: pointer;
  }
`
export const CancelButton = styled.button`
  border: 1px solid #535353;
  background-color: #fff;
`

export const SubmitButton = styled.button`
  background-color: #535353;
  color: #fff;
`
export const DelButton = styled.button`
  width: 150px;
  height: 45px;
  border-radius: 5px;
  background-color: ${mainColor};
  color: #fff;
  font-size: 15px;
  cursor: pointer;

  &:hover {
    background-color: ${subColor};
    border-color: #1B4F72;
  }
`

export const DefaultButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 35px;
  border: 1px solid ${lightGray};
  background-color: ${mainColor};
  color: ${whiteColor};
`
export const DeleteButton = styled.button`
  width: 24px;
  height: 24px;
  background-color: transparent;
  background-image: url("/assets/images/common/btn_delete_off.png");
  background-image: -webkit-image-set(url("/assets/images/common/btn_delete_off.png") 1x, url("/assets/images/common/btn_delete_off@2x.png") 2x, url("/assets/images/common/btn_delete_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  &:hover {
    background-image: url("/assets/images/common/btn_delete_on.png");
    background-image: -webkit-image-set(url("/assets/images/common/btn_delete_on.png") 1x, url("/assets/images/common/btn_delete_on@2x.png") 2x, url("/assets/images/common/btn_delete_on@3x.png") 3x);
  }
`
export const ValidationScript = styled.div`
  position: absolute;
  bottom: -20px;
  left: 5px;
  color: #f55a5a;
  font-size: 12px !important;
`
export const Input = styled('input')`
  padding: 2px 8px;
  width: 100%;
  font-size: 14px;
  border: 1px solid #e5e5e5;
  height: 35px;
  border-radius: 5px;
  .btn-delete {
    width: 35px;
    height: 35px;
    background-image: url("/assets/images/common/btn_delete_off.png");
    background-image: -webkit-image-set(url("/assets/images/common/btn_delete_off.png") 1x, url("/assets/images/common/btn_delete_off@2x.png") 2x, url("/assets/images/common/btn_delete_off@3x.png") 3x);
    background-repeat: no-repeat;
    background-position: center;
    &:hover {
      background-image: url("/assets/images/common/btn_delete_on.png");
      background-image: -webkit-image-set(url("/assets/images/common/btn_delete_on.png") 1x, url("/assets/images/common/btn_delete_on@2x.png") 2x, url("/assets/images/common/btn_delete_on@3x.png") 3x);
    }
  }
`
export const InputLabel = styled.div`
  width: ${(props) => props?.width !== undefined ? props?.width : '100%'};
  & > input {
    padding: 0 40px 0 20px;
  }
  &:after {
    display: inline-block;
    content: ${(props) => props?.label !== undefined && `'${props?.label}'`};
    margin-left: -35px;    
  }
`
export const RelativeDiv = styled.div`
  position: relative;
  width: 100%;
  & > * {
    margin-right: 10px;
  }
`
export const AbsoluteDiv = styled.div`
  position: absolute;
  top: 10px;
  left: 50px;
  padding: 7px 12px;
  z-index: 1000;
  border: 1px solid ${lightGray};
  background-color: #f3f3f3;
  & > * {
    margin-right: 10px;
  }
`

export const TableButton = styled.button`
  padding: 7px 12px;
  border: 1px solid ${lightGray};
  background-color: #f3f3f3;
  border-radius: 5px;
`

export const Script = styled.div`
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-image: url("/assets/images/table/icon_pop_off@2x.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_pop_off.png") 1x, url("/assets/images/table/icon_pop_off@2x.png") 2x, url("/assets/images/table/icon_pop_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  &:hover {
    background-image: url("/assets/images/table/icon_pop_on@2x.png");
    background-color: #f9fafb;
    cursor: pointer;
  }
`

export const Site = styled.div`
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-image: url("/assets/images/table/icon_url_off.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_url_off.png") 1x, url("/assets/images/table/icon_url_off@2x.png") 2x, url("/assets/images/table/icon_url_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  &:hover {
    background-image: url("/assets/images/table/icon_url_on.png");
    background-color: #f9fafb;
    cursor: pointer;
  }
`

export const CopyCode = styled.div`
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-image: url("/assets/images/table/icon_copy_off.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_copy_off.png") 1x, url("/assets/images/table/icon_copy_off@2x.png") 2x, url("/assets/images/table/icon_copy_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  &:hover {
    background-color: #f9fafb;
    cursor: pointer;
    background-image: url("/assets/images/table/icon_copy_on.png");
  }
`
export const Memo = styled.div`
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-image: url("/assets/images/table/icon_memo.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_memo.png") 1x, url("/assets/images/table/icon_memo@2x.png") 2x, url("/assets/images/table/icon_memo@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  &:hover {
    cursor: pointer;
    background-image: url("/assets/images/table/icon_memo_on.png");
    background-image: -webkit-image-set(url("/assets/images/table/icon_memo_on.png") 1x, url("/assets/images/table/icon_memo_on@2x.png") 2x, url("/assets/images/table/icon_memo_on@3x.png") 3x);
  }
`
export const ReportsDetail = styled.div`
  margin-left: 10px;
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-image: url("/assets/images/table/icon_pop_off@2x.png");
  background-image: -webkit-image-set(url("/assets/images/table/icon_pop_off.png") 1x, url("/assets/images/table/icon_pop_off@2x.png") 2x, url("/assets/images/table/icon_pop_off@3x.png") 3x);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  &:hover {
    background-color: #f9fafb;
    background-image: url("/assets/images/table/icon_pop_on@2x.png");
  }
`

export const DashBoardBody = styled.div`
  display: block;
`

export const RevenueBoard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px 12px 24px;
  border-radius: 8px;
  min-height: 58px;
  background-image: linear-gradient(135deg, ${mainColor}, ${subColor});
  box-shadow: 0 8px 18px rgba(30, 58, 138, .16);
  color: #fff;
  & div {
    display: flex;
    align-items: center;
    & > span {
      font-size: 25px;
      font-weight: 800;
    }
  }
`

export const Rating = styled.div`
  height: 30px;
  margin: 9px 0 5px 20px;
  padding: 5px 10px;
  border-radius: 6px;
  background-color: ${whiteColor};
  & > span {
    content:"";
    display: inline-block;
    margin-right: 10px;
    width: 10px;
    height: 10px;
    background-color: #000;
    Webkit-mask-image: url("/assets/images/common/icon_dropup.png");
    Webkit-mask-repeat: no-repeat;
    Webkit-mask-position: center;
    Webkit-mask-size: contain;
    mask-image: url("/assets/images/common/icon_dropup.png");
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }
  &:after {
   color: #000; 
  }
`

export const DailyBoard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-left: 3px solid ${subColor};
    padding: 2px 14px;
    width: 100%;
  }
`

export const Price = styled.div`
  font-size: 15px;
  font-weight: 700;
`

export const BigPrice = styled.div`
  font-size: 20px;
  font-weight: 700;
`

export const ColoredBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  padding: 20px;
  border-radius: 10px;
`

export const PieChartContainer = styled.div`
  display: flex;
  height: 230px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
`

export const DashBoardBodyColSpan = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  & > div:nth-child(1) {
    background-image: linear-gradient(135deg, ${mainColor}, ${subColor});
    color: ${whiteColor};
  }
  & > div:nth-child(2) {
    background-image: linear-gradient(135deg, ${mainColor}, ${subColor});
    color: ${whiteColor};
  }
  & > div:nth-child(3) {
    background-image: linear-gradient(135deg, ${mainColor}, ${subColor});
    color: ${whiteColor};
  }
  & > div img {
    width: 45px
  }
`

export const PieChartTap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
  width: 20%;
  border-right: 1px solid #e9ebee;
  & > div {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 10px;
    cursor: pointer;
    border-right: 4px solid #fff;
  }
  & > div:hover {
    border-right: 4px solid ${mainColor};
  }
`

export const PieChart = styled.div`
  width: 80%;
`

export const DashBoardWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  height: calc(100% - 40px);
  & > div {
    width: 50%;
  }
`

export const LastThirtyDaysItem = styled.div`
  display: flex;
  align-items: center;
  border-top: 1px solid #e9ebee;
  //border-bottom: 1px solid #e9ebee;
  & > div:first-child {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 64px;
    border-radius: 20px;
    background-color: #fff;
  }
  & > div:last-child {
    padding-left: 15px;
  }
  &:nth-child(n+3) {
    border-top: 0;
  }
`
export const ChartLabel = styled.div`
  display: flex;
  gap: 30px;
  padding: 0 24px;
  background: #f8fafc;
  & > div {
    display: flex;
    align-items: center;
    height: 42px;
    color: #64748b;
    font-size: 11px;
    font-weight: 650;
    cursor: pointer;
    border-bottom: 3px solid transparent
  }
  & > div:hover {
    border-bottom: 3px solid ${subColor};
    color: ${mainColor};
  }
`

export const PieChartCentered = styled.div`
  position: relative;
  width: 100%;
  height: 230px;
`

export const CenteredInfo = styled.div`
  position: absolute;
  left: calc(50% - 20px);
  top: 50%;
  transform: translate(-50%, -50%);
  & div {
    text-align: center;
    font-size: 12px;
    font-weight: bold;
  }
`

export const HandleButton = styled.button`
  width: 50px;
  height: 45px;
  font-size: 25px;
  background-color: transparent;

  &:hover {
    color: #0e0e41;
  }
`

export const TableTooltip = styled.div`
  &:hover > div {
    display: block;
  }
`
export const ToolTipText = styled.div`
  
`
export const TooltipBody = styled.div`
  display: none;
  position: absolute;
  background-color: #fff;
  border: 1px solid #ddd;
  top: 10px;
  right: -10px;
  padding: 10px;
  border-radius: 5px
`

export const TextArea = styled.textarea`
  width: 100%;
  padding-top: 10px;
  padding-left: 10px;
  border: 1px solid rgb(229, 229, 229);
  border-radius: 5px;
  resize: none;
  ::placeholder {
    color: #bbb;
  }
  :read-only {
    cursor: not-allowed;
    background-color: #eee;
  }
`

export const selectStyle = {
  indicatorSeparator: () => null,
  indicatorsContainer: (baseStyles,state) => (
      {
        ...baseStyles,
        height: '100%',
      }
  ),
  container:(baseStyles,{selectProps}) => (
      {
        ...baseStyles,
        width: selectProps.width !== undefined ? selectProps.width : '100%',
        height: '100%',
      }
  ),
  valueContainer: (baseStyles,state) => (
      {
        ...baseStyles,
        height: '100%',
      }
  ),
  option: (baseStyles,{isDisabled,isSelected,isFocused}) => (
      {
        ...baseStyles,
        backgroundColor:
            isDisabled ? undefined :
                isSelected ?  mainColor:
                    isFocused ? mainColor
                        :undefined,
        color:
            isDisabled ? lightGray :
                isSelected ? '#fff' : textColor,
        ':active': {
          ...baseStyles[':active'],
          backgroundColor: !isDisabled ?
              isSelected ? mainColor
                  : undefined
              :undefined

        }
      }),
  control: (baseStyles,{selectProps,isFocused}) => (
      {
        ...baseStyles,
        width: selectProps.width !== undefined ? selectProps.width : '100%',
        minHeight: 30,
        marginRight: '0 !important',
        borderColor: lightGray,
        boxShadow: isFocused && `0 0 0 1px ${mainColor}`,
        ':hover': {
          ...baseStyles[':hover'],
          borderColor: isFocused && mainColor
        }
      }
  ),
  input: (baseStyles,state) => (
      {
        ...baseStyles,
        width: '100%',
        height: 40 - 10,
        borderRadius: 5,
      }
  )
}
